import { deleteKeysObject, exists, removeDBObjectKeys, tsValidate, tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { MessageType_Image, MessageType_Text, MessageType_Video } from './types.js';
import { MessagingDBGroup } from '../consts.js';
/**
 * Utility object containing type guard methods for different message types
 */
export const MessageTools = {
    isText: (instance) => {
        return instance.type === 'text';
    },
    isImage: (instance) => {
        return instance.type === 'image';
    },
    isVideo: (instance) => {
        return instance.type === 'video';
    }
};
/**
 * Validator for automatically generated message properties
 */
const Validator_GeneratedProps_Text = {
    _auditorId: tsValidateUniqueId,
};
/**
 * Base validator for common message properties
 */
const Validator_BaseMessage = {
    topicId: tsValidateUniqueId,
};
const Validator_DB_Message_Image = {
    ...Validator_BaseMessage,
    type: tsValidateValue([MessageType_Image]),
    url: tsValidateString(),
};
const Validator_DB_Message_Video = {
    ...Validator_BaseMessage,
    type: tsValidateValue([MessageType_Video]),
};
const Validator_DB_Message_Text = {
    ...Validator_BaseMessage,
    type: tsValidateValue([MessageType_Text]),
    text: tsValidateString(),
};
/**
 * Validates modifiable properties of a message based on its type
 *
 * @param instance - The message instance to validate
 * @returns Validation result or error message
 */
const Validator_ModifiableProps_Message = (instance) => {
    if (!exists(instance))
        return 'No object received';
    const __toValidate = deleteKeysObject(removeDBObjectKeys(instance), ['_auditorId']);
    switch (instance?.type) {
        case MessageType_Text:
            return tsValidate(__toValidate, Validator_DB_Message_Text);
        case MessageType_Image:
            return tsValidate(__toValidate, Validator_DB_Message_Image);
        case MessageType_Video:
            return tsValidate(__toValidate, Validator_DB_Message_Video);
        default:
            // @ts-ignore
            return `Could not find message type('${instance.type}') when attempting to validate a message!`;
    }
};
/**
 * Database definition for messages
 * Includes validation rules, versioning, and database configuration
 */
export const DBDef_message = {
    modifiablePropsValidator: Validator_ModifiableProps_Message,
    generatedPropsValidator: Validator_GeneratedProps_Text,
    versions: ['1.0.0'],
    dbKey: 'messages',
    frontend: {
        group: MessagingDBGroup,
        name: 'message',
    },
    backend: {
        name: 'messages'
    },
    entityName: 'Message',
};
//# sourceMappingURL=db-def.js.map